import React from 'react';
import LabelWithTooltip from './CustomLabel';

interface ToggleButtonGroupProps {
  label?: string;
  optionOne: string;
  optionTwo: string;
  optionThree?: string;
  optionFour?: string;
  selectedOption: string;
  className?:string;
  tooltip?:string;
  onOptionChange: (selected: string) => void;
}

const ZToggleButtonGroup: React.FC<ToggleButtonGroupProps> = ({ label, optionOne, tooltip, optionTwo, optionThree,optionFour, selectedOption, className='btn-light-primary', onOptionChange }) => {

  return (
    <div>
      {label && (
        <div>
          <LabelWithTooltip labelText={label} tooltipText={tooltip} />
        </div>
      )}
      <div
        className="d-flex flex-nowrap overflow-hidden"
        title={!label ? tooltip?.toTranslatedDisplay() : undefined}
      >
        <button
          type="button"
          className={`btn ${className} rounded-0 rounded-start btn-sm ${selectedOption === optionOne ? 'active fw-bold' : ''}`}
          onClick={() => onOptionChange(optionOne)}
        >
          {optionOne.toTranslatedDisplay()}
        </button>
        <button
          type="button"
          className={`btn ${className} rounded-0 ${(!optionThree) && 'rounded-end'} btn-sm ${selectedOption === optionTwo ? 'active fw-bold' : ''}`}
          onClick={() => onOptionChange(optionTwo)}
        >
          {optionTwo.toTranslatedDisplay()}
        </button>
        {optionThree &&
          <button
          type="button"
          className={`btn ${className} rounded-0 ${(!optionFour) && 'rounded-end'} btn-sm ${selectedOption === optionThree ? 'active fw-bold' : ''}`}
          onClick={() => onOptionChange(optionThree)}
        >
          {optionThree.toTranslatedDisplay()}
        </button>
        }
        {optionFour &&
          <button
          type="button"
          className={`btn ${className} rounded-0 rounded-end btn-sm ${selectedOption === optionFour ? 'active fw-bold' : ''}`}
          onClick={() => onOptionChange(optionFour)}
        >
          {optionFour.toTranslatedDisplay()}
        </button>
        }
      </div>
    </div>
  );
};

export default ZToggleButtonGroup;
